// extracted by mini-css-extract-plugin
export default {"container":"TemplateList_container__mWb0F"};